import React from 'react'
import { injectIntl } from 'react-intl'

import Button from '@uniiverse/library/components/button'

import { MAIN_CATEGORIES, OTHER_CATEGORY } from 'src/lib/categories'
import { trackAmplitude } from 'src/lib/analytics'

import { Radio } from '../radio/index'

import locale from '../search-filter/locale'
import style from './index.css'

export class FiltersComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      category: props.category,
      time: props.time,
      price: props.price,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.category !== prevProps.category) {
      this.setState({ category: this.props.category })
    }

    if (this.props.time !== prevProps.time) {
      this.setState({ time: this.props.time })
    }

    if (this.props.price !== prevProps.price) {
      this.setState({ price: this.props.price })
    }
  }

  onSubmit = (e) => {
    e.preventDefault()
  }

  changeCategory = (e) => {
    this.setState({ category: e.target.value })
  }

  changeTime = (e) => {
    this.setState({ time: e.target.value })
  }

  changePrice = (e) => {
    this.setState({ price: e.target.value })
  }

  filter = () => {
    const { searchParams } = new URL(window.location)
    searchParams.set('categories', encodeURIComponent(this.state.category))
    searchParams.set('time', encodeURIComponent(this.state.time))
    searchParams.set('price', encodeURIComponent(this.state.price))
    const url = `/explore?${searchParams.toString()}`
    this.props.history.push(url)
    trackAmplitude('Apply Filters', { category: this.state.category, time: this.state.time }, this.props.viewer)
    this.props.close()
    if (this.props.onFilter) this.props.onFilter()
  }

  render() {
    const { intl: { formatMessage } } = this.props

    const categories = [
      { id: 'all-categories', value: '', locale: locale.categoryAll },
      ...MAIN_CATEGORIES,
      OTHER_CATEGORY,
    ].map(category => ({ ...category, text: formatMessage(category.locale) }))
    const times = [
      { id: 'all-times', value: '', text: formatMessage(locale.anyDate) },
      { value: 'today', text: formatMessage(locale.timeToday) },
      { value: 'this-week', text: formatMessage(locale.timeThisWeek) },
      { value: 'this-weekend', text: formatMessage(locale.timeThisWeekend) },
      { value: 'next-week', text: formatMessage(locale.timeNextWeek) },
    ]
    const prices = [
      { id: 'all-prices', value: '', text: formatMessage(locale.priceAll) },
      { value: 'free', text: formatMessage(locale.priceFree) },
    ]

    return (
      <div className={`${style.container} ${this.props.opened ? style.containerOpened : ''}`}>
        <form action="#" className={style.content} onSubmit={this.onSubmit}>
          <div className={style.filters}>
            <div className={style.categories}>
              <div className={style.label}>
                {formatMessage(locale.category)}
              </div>
              {categories.slice(0, 7).map(c => (
                <div key={c.value}>
                  <Radio
                    inputProps={{
                      id: c.id || c.value,
                      name: 'category',
                      onChange: this.changeCategory,
                      checked: c.value === this.state.category,
                      value: c.value,
                    }}
                    labelText={c.text}
                    labelProps={{ htmlFor: c.id || c.value }}
                  />
                  <br />
                </div>
              ))}
            </div>
            <div className={style.categoriesNext}>
              {categories.slice(7).map(c => (
                <div key={c.value}>
                  <Radio
                    inputProps={{
                      id: c.id || c.value,
                      name: 'category',
                      onChange: this.changeCategory,
                      checked: c.value === this.state.category,
                      value: c.value,
                    }}
                    labelText={c.text}
                    labelProps={{ htmlFor: c.id || c.value }}
                  />
                  <br />
                </div>
              ))}
            </div>
            <div className={style.times}>
              <div className={style.label}>
                {formatMessage(locale.when)}
              </div>
              {times.map(c => (
                <div key={c.value}>
                  <Radio
                    inputProps={{
                      id: c.id || c.value,
                      name: 'when',
                      onChange: this.changeTime,
                      checked: c.value === this.state.time,
                      value: c.value,
                    }}
                    labelText={c.text}
                    labelProps={{ htmlFor: c.id || c.value }}
                  />
                  <br />
                </div>
              ))}
            </div>
            <div className={style.prices}>
              <div className={style.label}>
                {formatMessage(locale.price)}
              </div>
              {prices.map(c => (
                <div key={c.value}>
                  <Radio
                    inputProps={{
                      id: c.id || c.value,
                      name: 'price',
                      onChange: this.changePrice,
                      checked: c.value === this.state.price,
                      value: c.value,
                    }}
                    labelText={c.text}
                    labelProps={{ htmlFor: c.id || c.value }}
                  />
                  <br />
                </div>
              ))}
            </div>
          </div>
          <div className={style.footer}>
            <Button type="primary" onClick={this.filter}>
              {formatMessage(locale.action)}
            </Button>
            <button className={style.close} onClick={this.props.close}>
              {formatMessage(locale.close)}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export const Filters = injectIntl(FiltersComponent)
